import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';
const STATES=['NO_COMPOUND_SIGNAL','BUILDING_NEGATIVE','BUILDING_POSITIVE','COMPOUND_NEGATIVE','COMPOUND_POSITIVE','COMPOUND_MIXED'];

function norm(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    state:STATES.includes(x.state)?x.state:'NO_COMPOUND_SIGNAL',
    negativeWeight:Number.isFinite(x.negativeWeight)?Math.max(0,x.negativeWeight):0,
    positiveWeight:Number.isFinite(x.positiveWeight)?Math.max(0,x.positiveWeight):0,
    negativeDomains:Number.isFinite(x.negativeDomains)?Math.max(0,Math.floor(x.negativeDomains)):0,
    positiveDomains:Number.isFinite(x.positiveDomains)?Math.max(0,Math.floor(x.positiveDomains)):0,
    fingerprint:x.fingerprint||null
  });
}

function severity(state){
  const rank={
    NO_COMPOUND_SIGNAL:0,
    BUILDING_POSITIVE:1,
    BUILDING_NEGATIVE:2,
    COMPOUND_POSITIVE:2,
    COMPOUND_MIXED:3,
    COMPOUND_NEGATIVE:4
  };
  return rank[state]??0;
}

function compare(previous,current){
  const p=norm(previous), c=norm(current);
  const changes=[];
  if(p.state!==c.state) changes.push('STATE');
  if(p.negativeDomains!==c.negativeDomains) changes.push('NEGATIVE_DOMAINS');
  if(p.positiveDomains!==c.positiveDomains) changes.push('POSITIVE_DOMAINS');
  if(p.fingerprint!==c.fingerprint) changes.push('EVIDENCE');

  const negDelta=+(c.negativeWeight-p.negativeWeight).toFixed(3);
  const posDelta=+(c.positiveWeight-p.positiveWeight).toFixed(3);

  let deltaState='UNCHANGED';
  if(!previous) deltaState='NEW';
  else if(severity(c.state)>severity(p.state)) deltaState='ESCALATED';
  else if(severity(c.state)<severity(p.state)) deltaState='DE_ESCALATED';
  else if(changes.length || Math.abs(negDelta)>=.2 || Math.abs(posDelta)>=.2) deltaState='CHANGED';

  return Object.freeze({
    symbol:c.symbol||p.symbol,
    previousState:p.state,
    currentState:c.state,
    deltaState,
    negativeWeightDelta:negDelta,
    positiveWeightDelta:posDelta,
    changes:Object.freeze(changes),
    tradeSignal:false,
    capitalPermission:false
  });
}

function material(delta){
  const d=delta||{};
  if(['NEW','ESCALATED','DE_ESCALATED'].includes(d.deltaState)) return true;
  if(d.deltaState==='CHANGED' && (Math.abs(d.negativeWeightDelta||0)>=.3 || Math.abs(d.positiveWeightDelta||0)>=.3)) return true;
  return false;
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const a={symbol:'AAA',state:'BUILDING_NEGATIVE',negativeWeight:.7,positiveWeight:.1,negativeDomains:2,positiveDomains:0,fingerprint:'a'};
  const b={symbol:'AAA',state:'COMPOUND_NEGATIVE',negativeWeight:1.4,positiveWeight:.1,negativeDomains:3,positiveDomains:0,fingerprint:'b'};
  const c={symbol:'AAA',state:'NO_COMPOUND_SIGNAL',negativeWeight:.2,positiveWeight:.1,negativeDomains:1,positiveDomains:0,fingerprint:'c'};

  ok('compound escalation detected',compare(a,b).deltaState==='ESCALATED');
  ok('compound de-escalation detected',compare(b,c).deltaState==='DE_ESCALATED');
  ok('unchanged compound state stays unchanged',compare(a,a).deltaState==='UNCHANGED');
  ok('evidence fingerprint change is explicit',compare(a,{...a,fingerprint:'z'}).changes.includes('EVIDENCE'));
  ok('negative weight delta is calculated',compare(a,b).negativeWeightDelta===.7);
  ok('escalation is always material',material(compare(a,b))===true);
  ok('de-escalation is material',material(compare(b,c))===true);
  ok('small same-state movement can stay non-material',material(compare(a,{...a,negativeWeight:.75}))===false);
  ok('large same-state movement becomes material',material(compare(a,{...a,negativeWeight:1.1}))===true);
  ok('delta emits no trade signal',compare(a,b).tradeSignal===false);
  ok('delta grants no capital permission',compare(a,b).capitalPermission===false);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,STATES,norm,severity,compare,material,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestCompoundSignalDeltaEngine=Object.freeze(API);
})(engineContext);
